module.exports = __webpack_public_path__ + "static/img/groundabout8.1ef74d63.png";